import { createContext } from 'react';

export const WorkflowInitialContext = createContext({} as any);
